import { StatsUpSquare } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconStatsUpSquare12Line = createIcon(StatsUpSquare, 12, "Line");
export const IconStatsUpSquare16Line = createIcon(StatsUpSquare, 16, "Line");
export const IconStatsUpSquare20Line = createIcon(StatsUpSquare, 20, "Line");
export const IconStatsUpSquare24Line = createIcon(StatsUpSquare, 24, "Line");
export const IconStatsUpSquare32Line = createIcon(StatsUpSquare, 32, "Line");
export const IconStatsUpSquare48Line = createIcon(StatsUpSquare, 48, "Line");
export const IconStatsUpSquare64Line = createIcon(StatsUpSquare, 64, "Line");
